<template>
  <input
    :class="{ 'input--validation-error': error }"
    type="text"
    v-model="inputValue"
    :id="id || null"
    :maxlength="maxlength > 0 ? maxlength : null"
    :placeholder="placeholder"
    :disabled="isDisabled"
    @keyup.enter="emitEnter"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * テキストインプットフィールド
 */
export default defineComponent({
  name: 'AtomInputText',
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Value値
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * Error判定
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * プレースホルダー
     */
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * maxlength値
     */
    maxlength: {
      type: Number,
      default: 0,
    },
    /**
     * 非活性フラグ
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    /**
     * インプットの値
     * @param {string} val インプットの値
     */
    const inputValue = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })

    return {
      inputValue,
    }
  },
  methods: {
    /**
     * エンターキーが押されたことを通知する
     */
    emitEnter() {
      /**
       * エンターキーが押されたことを通知する
       * @event enter
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>
